import { useEffect, useState } from "react";
import { api } from "../lib/api";
import BusinessCard from "../components/BusinessCard";
import { Loader2 } from "lucide-react";

export default function Businesses() {
  const [businesses, setBusinesses] = useState([]);
  const [conn, setConn] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/businesses").then((r) => setBusinesses(r.data)).finally(() => setLoading(false));
    api.get("/ecosystem/dashboard")
      .then((r) => setConn(Object.fromEntries(r.data.entities.map((e) => [e.id, e.connection_status]))))
      .catch(() => setConn(false));
  }, []);

  return (
    <div className="max-w-7xl">
      <p className="text-xs uppercase tracking-widest text-[#581C87] font-semibold">
        Business Registry
      </p>
      <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight mt-2">
        Businesses
      </h1>
      <p className="text-gray-500 mt-2">
        Every registered business operating system in the ecosystem.
      </p>

      {loading ? (
        <div className="flex justify-center py-20">
          <Loader2 className="h-6 w-6 animate-spin text-[#581C87]" />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8" data-testid="businesses-grid">
          {businesses.map((b, i) => (
            <BusinessCard key={b.id} business={b} index={i} connection={conn === false ? "unavailable" : conn?.[b.id]} />
          ))}
        </div>
      )}
    </div>
  );
}
